var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col min-h-screen"},[_c('app-navbar'),_c('main',{staticClass:"main",style:({
      paddingTop: _vm.headerHeight + 'px',
    })},[_c('transition',{attrs:{"name":"page","appear":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }